import { render, staticRenderFns } from "./userApproval.vue?vue&type=template&id=1be4545a&"
import script from "./userApproval.vue?vue&type=script&lang=js&"
export * from "./userApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports